<template>
  <v-card
    class="secondary--text"
    height="100%"
    style="box-shadow: 15px 15px 40px #00000029;border-radius: 20px;"
  >
    <v-card-title class="font-weight-bold mx-4 pt-8">
      <div>{{ title }}</div>
    </v-card-title>
    <div style="height: 250px">
      <vue-scroll :ops="ops">
        <div
          v-for="document in documents"
          :key="document.id"
          class="mx-4"
        >
          <v-container class="py-0">
            <v-row align="center">
              <v-col cols="2">                
                <i 
                  :class="`icofont-file-${fileExtension(document.filename)} icofont-2x uploaded-file-icon`" 
                  @click="handleFileView(document)"
                />
              </v-col>
              <v-col
                cols="8"
                class="secondary--text text-left"
              >
                <div 
                  class="font-weight-medium" 
                  style="cursor: pointer"
                  @click="handleFileView(document)"
                >               
                  {{ document.name }}
                </div>
                <div style="font-size: 0.8rem">
                  Submitted: {{ formatDate(document.created_at) }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </vue-scroll>      
    </div>
    <div class="card-action-bottom">
      <v-btn
        color="accent_light"
        class="px-4 white--text"
        rounded
        depressed
        @click="$router.push(`/case-view/${$route.params.id}/${title.toLowerCase()}`)"
      >
        View All
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex"
import { openPDFInNewTab } from "../utils";
import PDFTemplateData from '@/mixins/pdf-template-data';
import writtenNumber from "written-number";

export default {
  name: 'DocListCard',
  mixins: [PDFTemplateData],
  props:{
    title: {
      type: String,
      default: ''
    },
    documents: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return{
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          //background: '#EAEBEB',
          opacity: 0,
          size: '5px',
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: '0px',
        },
        bar: {
          onlyShowBarOnScroll: false,
          keepShow: true,
          background: '#4DCCC4',
          opacity: 1,
          size: '6px',
        }
      },
      serverURL: process.env.VUE_APP_URL
    }
  },
  computed: {
    ...mapGetters({
      currentCase: "eviction/currentCase",
      case: "eviction/currentCase",
      currentProperty: "property/currentProperty",
      courtInfo: "eviction/courtInfo",
      orderDetails: "eviction/orderDetails",
      client: "client",
      mileage: "eviction/mileage",
    }),
  },
  created() {},
  methods:  {
    fileExtension(fileName){
      const fileExt = fileName.split(".")[1]
      switch (fileExt) {
        case 'doc':
        case 'docx':
          return 'word'
        case 'pdf':
          return 'pdf'
        case 'csv':
        case 'xlsx':
          return 'excel'
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'img':
          return 'image'
        default:
          return 'text';
      }
    },
    async handleFileView(document) {
      if (this.title === "Pleadings") {
        const tenantsLength = this.currentCase.tenants.length * 2;
        const fileName = document.templateName || document.filename.split(".")[0]

        const courtAddressState = this.mileage.courtAddress;

        const courtAddress = {
          countyCourt: courtAddressState.county,
          streetAddressCourt: courtAddressState.street,
          cityCourt: courtAddressState.city,
          stateCourt: courtAddressState.state,
          zipcodeCourt: courtAddressState.zipcode,
          phoneCourt: courtAddressState.phone
        }

        const data = {
          fileType: document.name.trim(),
          templateName: fileName,
          pleadings: 1,
          data: {
            filingType: this.currentCase.filingPlan,
            tenantFullNames: this.currentCase.tenants.map(tenant => tenant.name.trim().toUpperCase()).join(", "),
            exportDate: this.$dayjs().format("MMMM D, YYYY"),
            fileCopyAmount: `${writtenNumber(tenantsLength)} (${tenantsLength})`,
            ownerName: this.currentProperty.deedNames.toUpperCase(),
            section8: this.currentCase.section8,
            ...courtAddress,
            ...this.currentProperty.contactInfo,
            ...await this.getTemplateData()
          }
        };

        const response = await this.$http.post(`${process.env.VUE_APP_URL}/api/order/create-case-pleading-pdf`, data);

        openPDFInNewTab(response.data.fileName, response.data.fileData);

        return;
      }

      this.$http
        .get(`${process.env.VUE_APP_URL}/presignedUrl?filename=document`+ document.id + `_` + document.filename, {
          params: {
            caseId: this.$route.params.id,
          },
        })
        .then((r) => r.data)
        .then((data) => {
          window.open(data, '_blank');
        });
    },
    formatDate(date) {
      return moment(date).format("MM.DD.YY");
    }
  }
}
</script>

<style>
  .card-action-bottom {
    padding: 25px 30px;
    background: #F8FAFB;
  }
  .uploaded-file-icon {
    color: #afc2ce;
    cursor: pointer;
  }
  .uploaded-file-icon:hover {
    color: #4dccc4 !important;
  }
</style>